import Measure from "../../api/types/Measure";
import normalizeMeasure from "../normalizer/normalizeMeasure";

type Normalized = ReturnType<typeof normalizeMeasure>

export default function denormalizeMeasure(normalized: Normalized, measureId: string): Measure | undefined {
    return normalized.measures[measureId];
}